import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthenticationService} from "../../services/authentication.service";

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const loggedIn = authService.getCurrentLoginStatus();

  if (loggedIn) {
    return true;
  }

  // User not logged in. Maybe not a normal route, maybe deep link.
  // Let's check if the user is still logged in.
  await authService.refreshUserState();
  // Now, let's try again
  if (authService.getCurrentLoginStatus()) {
    return true;
  } else {
    // User is really not logged in. Back to root
    router.navigate(['']);
    return false;
  }
};
